import { h, Fragment } from "preact";

export { h, Fragment };
